import RenderSwitch from "./functions/RenderSwitch";
import TicketListReportComponent from "../TicketListReportComponent";
import { Button, Stack, Typography } from "@mui/material";
import ImagesCmp from "../../ImagesCmp";
import ListaArquivos from "./ListaArquivos";
import React, { useState } from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { useTranslation } from "react-i18next";
import { avaliacaoType, ChecklistSubitemReport, ChecklistReportType } from "../../../types/reports/types";
import { ChecklistSubitem, ItemChecklist, ocorrenciaType } from "../../../types/checklist/types";

export default function ModalDetailContent({
  exibeTipo,
  itemIndex,
  showScoring,
  item,
  parentItem,
  ocorrencia,
  selected,
  showNotSelected,
  hideNAplica,
  showNumbers,
  hideAllFiles,
  hideAllImages,
}: {
  exibeTipo: boolean;
  itemIndex: number;
  showScoring?: boolean;
  item: ItemChecklist | ocorrenciaType;
  parentItem: ItemChecklist;
  ocorrencia?: ocorrenciaType;
  selected: ChecklistReportType;
  showNotSelected?: boolean;
  hideNAplica: boolean;
  showNumbers: boolean;
  hideAllFiles: boolean;
  hideAllImages: boolean;
}) {
  const [exibeArquivos, setExibeArquivos] = useState<number[]>([]);
  const [exibeImagens, setExibeImagens] = useState<number[]>([]);
  const { t } = useTranslation("translation");

  const toggleFiles = (index: number) => {
    setExibeArquivos((prev) => (prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]));
  };

  const toggleImages = (index: number) => {
    setExibeImagens((prev) => (prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]));
  };

  const verificaConformidade = (subItem: ChecklistSubitem) => {
    if (typeof subItem.threshold !== "number") {
      subItem.threshold = -1;
    }
    let valido = true;
    if (typeof subItem.nota === "number" && typeof subItem.threshold === "number") {
      if (subItem.nota <= subItem.threshold) {
        valido = false;
      }
    }
    return valido;
  };

  const tipoExibido = (value: string) => {
    switch (value) {
      case "avaliacao":
        return "(Avaliação)";
      case "multiple":
        return "(Multiplo)";
      case "unique":
        return "(Unico)";
      case "textoCurto":
        return "(Texto curto)";
      case "textoLongo":
        return "(Texto longo)";
      case "list":
        return "(Lista de textos)";
      case "email":
        return "(E-mail)";
      case "placa":
        return "(Placa)";
      case "cpfcnpj":
        return "(CPF / CNPJ)";
      case "cep":
        return "(CEP)";
      case "assinatura":
        return "(Assinatura)";
      case "rg":
        return "(RG)";
      case "data":
        return "(Data)";
      case "hora":
        return "(Hora)";
      case "telefone":
        return "(Telefone)";
      case "numero":
        return "(Numero)";
      case "valorMedida":
        return "(Valor/Medida)";
      default:
        return <div>AAAAAAA</div>;
    }
  };

  function checkNAplica(subitem: ChecklistSubitem) {
    if (subitem.tipo === "avaliacao") {
      if (typeof subitem.nota === "number") {
        const nAplica = subitem.avaliacao?.find((_ele: avaliacaoType, ind: number) => ind === subitem.nota);
        if (nAplica?.valor === -1 && !hideNAplica) return true;
      }
    }
    return false;
  }

  const exibeArquivosSubitem = (index: number): boolean => {
    if (exibeArquivos.includes(index)) {
      return hideAllFiles;
    }

    return !hideAllFiles;
  };

  const exibeImagensSubitem = (index: number): boolean => {
    if (exibeImagens.includes(index)) {
      return hideAllImages;
    }

    return !hideAllImages;
  };

  return (
    <Stack direction="column" justifyContent="flex-start" alignItems="flex-start" spacing={1}>
      <Typography color="textDisabled" variant="h6" sx={{ textDecoration: "underline" }}>
        {showNumbers && `(${itemIndex + 1}) - `}
        {item.nome}
      </Typography>
      {!showScoring && selected?.itens?.[itemIndex]?.scorePorcentagem && (
        <Typography fontSize="small" fontWeight={600}>
          Scoring item: {selected?.itens[itemIndex]?.scorePorcentagem}
        </Typography>
      )}
      <Stack paddingLeft={3} direction="column" justifyContent="center" alignItems="flex-start" spacing={1}>
        {item.subitens?.map((subitem: ChecklistSubitem, subIndex: number) => {
          return !subitem.checked ? (
            <></>
          ) : (
            <React.Fragment key={`${subitem.id}|${subIndex}`}>
              {!checkNAplica(subitem as ChecklistSubitem) && (
                <div style={{ pageBreakInside: "avoid" }}>
                  <Stack direction="row" justifyContent="flex-start" alignItems="center" spacing={1}>
                    <Typography fontWeight={600} sx={{ color: "gray", wordBreak: "break-word" }} variant="h6">
                      {showNumbers && `(${subIndex + 1}) - `} {subitem.nome}
                    </Typography>
                    {subitem.tipo === "avaliacao" && verificaConformidade(subitem as ChecklistSubitem) ? (
                      <CheckCircleIcon fontSize="small" color="success" />
                    ) : (
                      subitem.tipo === "avaliacao" &&
                      !verificaConformidade(subitem as ChecklistSubitem) && <CancelIcon fontSize="small" color="error" />
                    )}
                  </Stack>
                  {exibeTipo && (
                    <Typography fontSize="small" color="textDisabled">
                      {tipoExibido(subitem.tipo)}
                    </Typography>
                  )}
                  <Stack direction="column" alignItems="flex-start" justifyContent="flex-start" spacing={1}>
                    {RenderSwitch(subitem as ChecklistSubitemReport, showNotSelected as boolean, selected)}
                    {subitem?.img?.length && (
                      <>
                        <Stack direction="row" justifyContent="flex-start" alignItems="center" spacing={1}>
                          <Typography variant="subtitle2" fontSize={13} color="textDisabled" fontWeight={700} component="p">
                            {t("Reports.images")}
                          </Typography>
                          <Button
                            endIcon={exibeImagensSubitem(subitem.id as number) ? <VisibilityOffIcon /> : <RemoveRedEyeIcon />}
                            onClick={() => toggleImages(subitem.id as number)}>
                            {exibeImagensSubitem(subitem.id as number) ? t("Reports.hideImages") : t("Reports.showImages")}
                          </Button>
                        </Stack>
                        {exibeImagensSubitem(subitem.id as number) && <ImagesCmp images={subitem.img} />}
                      </>
                    )}
                    {!selected.preenchimentoDeslogado && subitem?.arquivos?.length && (
                      <>
                        <Stack direction="row" justifyContent="flex-start" alignItems="center" spacing={1}>
                          <Typography sx={{ marginTop: "5px" }} fontWeight={600} variant="subtitle1" color="textDisabled" fontSize={13}>
                            {t("Reports.files")}
                          </Typography>
                          <Button
                            endIcon={exibeArquivosSubitem(subitem.id as number) ? <VisibilityOffIcon /> : <RemoveRedEyeIcon />}
                            onClick={() => toggleFiles(subitem.id as number)}>
                            {exibeArquivosSubitem(subitem.id as number) ? t("Reports.hideFiles") : t("Reports.showFiles")}
                          </Button>
                        </Stack>
                        {exibeArquivosSubitem(subitem.id as number) && <ListaArquivos files={subitem.arquivos} />}
                      </>
                    )}
                  </Stack>
                </div>
              )}
              {selected?.itens?.[itemIndex]?.subitens[subIndex]?.scorePorcentagem && !showScoring && (
                <Typography fontSize="small" fontWeight={600}>
                  Scoring subitem: {selected?.itens[itemIndex]?.subitens[subIndex]?.scorePorcentagem}
                </Typography>
              )}
              {subitem?.chamadosConfig &&
                (() => {
                  const mobileSubitem = subitem as any;
                  const effectiveChamadosConfig = subitem?.chamadosConfig ?? {
                    chamadoObrigatorio: (subitem as ChecklistSubitem).ticketConfig!.mandatory as string,
                    limiteChamado: (subitem as ChecklistSubitem).ticketConfig?.limit ?? 0,
                    id: "",
                    nome: subitem?.nome,
                    tipo: subitem?.tipo,
                    tipoChamado: Array.isArray(mobileSubitem.tipoChamado) ? mobileSubitem.tipoChamado : [],
                  };
                  return (
                    <TicketListReportComponent
                      addingTickets={{
                        source: {
                          itemId: parentItem.id ?? null,
                          subitemId: subitem.id ?? null,
                          ocorrenciaId: ocorrencia?.id ?? null,
                        },
                        active: true,
                      }}
                      chamadosObj={subitem?.chamados}
                      chamadosConfig={effectiveChamadosConfig}
                      formId={selected.idForm ? selected.idForm : selected.id || "-"}
                      inicio={Number(selected.inicio)}
                      commingFromSub={true}
                      chamadosConfigSub={effectiveChamadosConfig}
                      selected={selected}
                    />
                  );
                })()}
            </React.Fragment>
          );
        })}
      </Stack>
    </Stack>
  );
}
